// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Pb3m","selected":"Chip_selected__1OjzX"};